import styled from '@emotion/styled';

import theme from 'styles/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media (min-width: 769px) {
    gap: 8px;
  }
`;

export const Title = styled.h1`
  margin: 0;
  font-family: 'Mangueira Bold', 'Mangueira', sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  color: ${theme.colors.blue};

  @media (min-width: 769px) {
    font-size: 24px;
    line-height: 1.2;
  }
`;

export const Description = styled.p`
  margin: 0;
  font-family: 'Mangueira', sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  color: #575757;

  @media (min-width: 769px) {
    font-size: 14px;
    line-height: 1.4;
    color: ${theme.colors.primaryText};
  }
`;
